export const modal = {
  topPosition: '50px',
  padding: '40px',
  plain: {
    width: '75%',
    padding: 0,
    background: 'transparent'
  }
};
